module.exports = __webpack_public_path__ + "img/vehicle.4b8a786e.png";